import React, { FC, useEffect } from 'react';
import { EntryPage } from '../../entrypages/EntryPage';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { changeLoanFormat, LOANFORMAT_ALL_OBJECT, loanFormatKeyToObject } from '../../../store/loanFormat/actions';

export const FeaturedForeignLanguageEntryPage: FC = () => {
    const dispatch = useDispatch();
    const { loanFormat } = useParams<{ loanFormat: string }>();

    useEffect(() => {
        const loanFormatString = !loanFormat ? LOANFORMAT_ALL_OBJECT : loanFormatKeyToObject(loanFormat);
        dispatch(changeLoanFormat(loanFormatString));
    }, [dispatch, loanFormat]);

    return <EntryPage pageType="LANGUAGE_LEARNING" />;
};
